<template>
  <div class="login-container">
    <div class="login-box">
      <!-- 登录状态提示 -->
      <div class="login-status" v-if="loginStatus !== 'idle'">
        <i class="el-icon-loading" v-if="loginStatus === 'loading'"></i>
        <i class="el-icon-success" v-if="loginStatus === 'success'"></i>
        <i class="el-icon-error" v-if="loginStatus === 'error'"></i>
        <span>{{ loginStatusText }}</span>
      </div>

      <!-- 选项卡：密码登录、验证码登录、账号注册 -->
      <div class="login-tabs">
        <div :class="['tab-item', { active: activeTab === 'pwdLogin' }]" @click="switchTab('pwdLogin')">
          密码登录
        </div>
        <div :class="['tab-item', { active: activeTab === 'smsLogin' }]" @click="switchTab('smsLogin')">
          验证码登录
        </div>
        <div :class="['tab-item', { active: activeTab === 'register' }]" @click="switchTab('register')">
          账号注册
        </div>
      </div>

      <!-- 密码登录表单 -->
      <div class="login-form" v-if="activeTab === 'pwdLogin'">
        <el-form :model="pwdLoginForm" ref="pwdLoginFormRef" :rules="pwdLoginRules" label-width="0px">
          <el-form-item prop="username">
            <el-input v-model="pwdLoginForm.username" placeholder="请输入手机号" prefix-icon="el-icon-user"
              :disabled="loginStatus === 'loading'" clearable></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input v-model="pwdLoginForm.password" type="password" placeholder="请输入密码" prefix-icon="el-icon-lock"
              :disabled="loginStatus === 'loading'" clearable></el-input>
          </el-form-item>
          <el-form-item prop="agreeProtocol" class="agree-protocol-item">
            <el-checkbox v-model="pwdLoginForm.agreeProtocol" :disabled="loginStatus === 'loading'"
              class="custom-checkbox">
              我已阅读并同意
              <a href="javascript:void(0)" class="protocol-link" @click="openProtocol('service')">《智步云上模型网服务协议》</a>
              <a href="javascript:void(0)" class="protocol-link" @click="openProtocol('privacy')">《智步云上模型网隐私政策》</a>
            </el-checkbox>
          </el-form-item>
          <el-form-item>
            <!-- 密码登录按钮：未勾选协议自动禁用 -->
            <el-button type="primary" style="width: 100%" @click="handlePwdLogin" :loading="loginStatus === 'loading'"
              :disabled="!pwdLoginForm.agreeProtocol || loginStatus === 'loading'">
              登录
            </el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 验证码登录表单 -->
      <div class="login-form" v-if="activeTab === 'smsLogin'">
        <el-form :model="smsLoginForm" ref="smsLoginFormRef" :rules="smsLoginRules" label-width="0px">
          <el-form-item prop="username">
            <el-input v-model="smsLoginForm.username" placeholder="请输入手机号" prefix-icon="el-icon-user"
              :disabled="loginStatus === 'loading'" clearable></el-input>
          </el-form-item>
          <el-form-item prop="smsCode">
            <el-input v-model="smsLoginForm.smsCode" placeholder="请输入验证码" prefix-icon="el-icon-key"
              :disabled="loginStatus === 'loading'" clearable>
              <template slot="append">
                <el-button type="text" @click="getSmsCode"
                  :disabled="!canGetCode || loginStatus === 'loading' || countdown > 0" class="code-btn">
                  {{ countdown > 0 ? `${countdown}秒后重新获取` : '获取验证码' }}
                </el-button>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="agreeProtocol" class="agree-protocol-item">
            <el-checkbox v-model="smsLoginForm.agreeProtocol" :disabled="loginStatus === 'loading'"
              class="custom-checkbox">
              我已阅读并同意
              <a href="javascript:void(0)" class="protocol-link" @click="openProtocol('service')">《智步云上模型网服务协议》</a>
              <a href="javascript:void(0)" class="protocol-link" @click="openProtocol('privacy')">《智步云上模型网隐私政策》</a>
              未注册过的手机号，我们将自动帮你注册账号
            </el-checkbox>
          </el-form-item>
          <el-form-item>
            <!-- 验证码登录按钮：未勾选协议自动禁用 -->
            <el-button type="primary" style="width: 100%" @click="handleSmsLogin" :loading="loginStatus === 'loading'"
              :disabled="!smsLoginForm.agreeProtocol || loginStatus === 'loading'">
              登录
            </el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 注册表单：用户名、密码、手机号、验证码 -->
      <div class="login-form" v-if="activeTab === 'register'">
        <el-form :model="registerForm" ref="registerFormRef" :rules="registerRules" label-width="0px">
          <el-form-item prop="userName">
            <el-input v-model="registerForm.userName" placeholder="请输入昵称" prefix-icon="el-icon-user-solid"
              :disabled="loginStatus === 'loading'" clearable></el-input>
          </el-form-item>
          <el-form-item prop="userPassword">
            <el-input v-model="registerForm.userPassword" type="password" placeholder="请设置登录密码"
              prefix-icon="el-icon-lock" :disabled="loginStatus === 'loading'" clearable></el-input>
          </el-form-item>
          <el-form-item prop="userPhone">
            <el-input v-model="registerForm.userPhone" placeholder="请输入手机号" prefix-icon="el-icon-user"
              :disabled="loginStatus === 'loading'" clearable></el-input>
          </el-form-item>
          <el-form-item prop="code">
            <el-input v-model="registerForm.code" placeholder="请输入验证码" prefix-icon="el-icon-key"
              :disabled="loginStatus === 'loading'" clearable>
              <template slot="append">
                <el-button type="text" @click="getRegisterCode"
                  :disabled="!canGetRegisterCode || loginStatus === 'loading' || countdown > 0" class="code-btn">
                  {{ countdown > 0 ? `${countdown}秒后重新获取` : '获取验证码' }}
                </el-button>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="width: 100%" @click="handleRegister" :loading="loginStatus === 'loading'">
              注册
            </el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="register-link">
        <el-button type="text" @click="goHome" style="float: left;color: #999;" icon="el-icon-arrow-left"
          :disabled="loginStatus === 'loading'">
          返回首页
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      // 默认激活密码登录
      activeTab: 'pwdLogin',
      // 密码登录表单
      pwdLoginForm: {
        username: '',
        password: '',
        agreeProtocol: false
      },
      // 验证码登录表单
      smsLoginForm: {
        username: '',
        smsCode: '',
        agreeProtocol: false
      },
      // 注册表单：匹配接口参数
      registerForm: {
        userName: '',
        userPassword: '',
        userPhone: '',
        code: ''
      },
      // 密码登录校验
      pwdLoginRules: {
        username: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '手机号格式错误', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度不少于6位', trigger: 'blur' }
        ],
        agreeProtocol: [
          { required: true, message: '请同意协议', trigger: 'change' }
        ]
      },
      // 验证码登录校验
      smsLoginRules: {
        username: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '手机号格式错误', trigger: 'blur' }
        ],
        smsCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ],
        agreeProtocol: [
          { required: true, message: '请同意协议', trigger: 'change' }
        ]
      },
      // 注册校验
      registerRules: {
        userName: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        userPassword: [
          { required: true, message: '请设置密码', trigger: 'blur' },
          { min: 6, message: '密码长度不少于6位', trigger: 'blur' }
        ],
        userPhone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '手机号格式错误', trigger: 'blur' }
        ],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      loginStatus: 'idle',
      loginStatusText: '',
      countdown: 0,
      timer: null
    };
  },
  computed: {
    // 验证码登录获取验证码权限
    canGetCode() {
      return /^1[3-9]\d{9}$/.test(this.smsLoginForm.username);
    },
    // 注册获取验证码权限
    canGetRegisterCode() {
      return /^1[3-9]\d{9}$/.test(this.registerForm.userPhone);
    }
  },
  created() {
    this.clearOldLoginData();
    this.restoreRememberedUser();
    this.listenEnterKey();
  },
  beforeDestroy() {
    this.timer && clearInterval(this.timer);
    window.removeEventListener('keydown', this.handleEnterKey);
  },
  methods: {
    // 回车提交
    listenEnterKey() {
      this.handleEnterKey = (e) => {
        if (e.keyCode === 13 && this.loginStatus !== 'loading') {
          e.preventDefault();
          this.activeTab === 'pwdLogin' && this.handlePwdLogin();
          this.activeTab === 'smsLogin' && this.handleSmsLogin();
          this.activeTab === 'register' && this.handleRegister();
        }
      };
      window.addEventListener('keydown', this.handleEnterKey);
    },

    clearOldLoginData() {
      localStorage.removeItem("token");
      sessionStorage.removeItem("token");
      localStorage.removeItem("userData");
      if (this.$apiFun && this.$apiFun.axios) {
        this.$apiFun.axios.defaults.headers.common['Authorization'] = '';
      }
    },

    restoreRememberedUser() {
      const user = localStorage.getItem("rememberedUser");
      if (user) {
        const { username } = JSON.parse(user);
        this.pwdLoginForm.username = username;
        this.smsLoginForm.username = username;
        this.registerForm.userPhone = username;
      }
    },

    // 切换选项卡
    switchTab(tab) {
      if (this.loginStatus === 'loading') return;

      clearInterval(this.timer);
      this.countdown = 0;

      this.activeTab = tab;
      this.$nextTick(() => {
        this.$refs.pwdLoginFormRef?.clearValidate();
        this.$refs.smsLoginFormRef?.clearValidate();
        this.$refs.registerFormRef?.clearValidate();
      });
    },

    // 验证码倒计时
    startCountdown() {
      this.countdown = 60;
      this.timer = setInterval(() => {
        this.countdown--;
        this.countdown <= 0 && clearInterval(this.timer);
      }, 1000);
    },

    // 获取登录验证码
    async getSmsCode() {
      if (!this.canGetCode) {
        this.loginStatus = 'error';
        this.loginStatusText = '手机号格式错误';
        setTimeout(() => this.loginStatus = 'idle', 2000);
        return;
      }
      this.loginStatus = 'loading';
      this.loginStatusText = '发送中...';
      try {
        const res = await this.$apiFun.getSendCodeV3({ PhoneNumbers: this.smsLoginForm.username });
        if (res.status === 200) {
          this.startCountdown();
          this.loginStatus = 'success';
          this.loginStatusText = '验证码发送成功';
        } else throw new Error(res.msg);
      } catch (err) {
        this.loginStatus = 'error';
        this.loginStatusText = err.message;
      }
      setTimeout(() => this.loginStatus = 'idle', 2000);
    },

    // 获取注册验证码
    async getRegisterCode() {
      if (!this.canGetRegisterCode) {
        this.loginStatus = 'error';
        this.loginStatusText = '手机号格式错误';
        setTimeout(() => this.loginStatus = 'idle', 2000);
        return;
      }
      this.loginStatus = 'loading';
      this.loginStatusText = '发送中...';
      try {
        const res = await this.$apiFun.getSendCodeV2({ PhoneNumbers: this.registerForm.userPhone });
        if (res.status === 200) {
          this.startCountdown();
          this.loginStatus = 'success';
          this.loginStatusText = '验证码发送成功';
        } else throw new Error(res.msg);
      } catch (err) {
        this.loginStatus = 'error';
        this.loginStatusText = err.message;
      }
      setTimeout(() => this.loginStatus = 'idle', 2000);
    },

    // 密码登录（对接指定接口）
    async handlePwdLogin() {
      try {
        await this.$refs.pwdLoginFormRef.validate();
      } catch {
        this.loginStatus = 'error';
        this.loginStatusText = '请完善登录信息';
        return;
      }

      this.loginStatus = 'loading';
      this.loginStatusText = '登录中...';
      try {
        // 对接密码登录接口
        const res = await this.$apiFun.postLoginPwd({
          username: this.pwdLoginForm.username,
          password: this.pwdLoginForm.password
        });

        if (res.status === 200) {
          this.loginStatus = 'success';
          this.loginStatusText = '登录成功';
          this.saveLoginData(res.obj);
          setTimeout(() => this.$router.push('/?refresh=true'), 1000);
        } else throw new Error(res.msg);
      } catch (err) {
        this.loginStatus = 'error';
        this.loginStatusText = err.message;
        setTimeout(() => this.loginStatus = 'idle', 2000);
      }
    },

    // 验证码登录
    async handleSmsLogin() {
      try {
        await this.$refs.smsLoginFormRef.validate();
      } catch {
        this.loginStatus = 'error';
        this.loginStatusText = '请完善登录信息';
        return;
      }

      this.loginStatus = 'loading';
      this.loginStatusText = '登录中...';
      try {
        const res = await this.$apiFun.postLogin({
          username: this.smsLoginForm.username,
          password: this.smsLoginForm.smsCode,
          code: this.smsLoginForm.smsCode
        });

        if (res.status === 200) {
          this.loginStatus = 'success';
          this.loginStatusText = '登录成功';
          this.saveLoginData(res.obj);
          setTimeout(() => this.$router.push('/?refresh=true'), 1000);
        } else throw new Error(res.msg);
      } catch (err) {
        this.loginStatus = 'error';
        this.loginStatusText = err.message;
        setTimeout(() => this.loginStatus = 'idle', 2000);
      }
    },

    // 注册（对接指定接口）
    async handleRegister() {
      try {
        await this.$refs.registerFormRef.validate();
      } catch {
        this.loginStatus = 'error';
        this.loginStatusText = '请完善注册信息';
        return;
      }

      this.loginStatus = 'loading';
      this.loginStatusText = '注册中...';
      try {
        // 对接注册接口，参数完全匹配
        const res = await this.$apiFun.postRegistrationUser(this.registerForm);

        if (res.status === 200) {
          this.loginStatus = 'success';
          this.loginStatusText = '注册成功，跳转到登录';
          setTimeout(() => {
            this.switchTab('pwdLogin');
            // 清空注册表单
            this.registerForm = { userName: '', userPassword: '', userPhone: '', code: '' };
            this.loginStatus = 'idle';
          }, 1500);
        } else throw new Error(res.msg);
      } catch (err) {
        this.loginStatus = 'error';
        this.loginStatusText = err.message;
        setTimeout(() => this.loginStatus = 'idle', 2000);
      }
    },

    // 保存登录信息
    saveLoginData(data) {
      localStorage.setItem("token", data.token);
      localStorage.setItem("userData", JSON.stringify(data));
      localStorage.setItem("rememberedUser", JSON.stringify({
        username: this.pwdLoginForm.username || this.smsLoginForm.username
      }));
      if (this.$apiFun && this.$apiFun.axios) {
        this.$apiFun.axios.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;
      }
    },

    goHome() { this.$router.push('/'); },
    openProtocol(type) {
      const path = type === 'service' ? '/protocol/service' : '/protocol/privacy';
      window.open(this.$router.resolve({ path }).href, '_blank');
    }
  }
};
</script>

<style lang="less" scoped>
.login-container {
  width: 100%;
  height: 100vh;
  background: url('./images/bg03.png');
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}

.login-box {
  width: 400px;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 8px;
  padding: 20px 30px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  max-height: 90vh;
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 4px;
  }

  ::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 2px;
  }

  ::-webkit-scrollbar-thumb {
    background: rgba(64, 158, 255, 0.5);
    border-radius: 2px;
  }
}

.login-status {
  padding: 10px;
  margin-bottom: 15px;
  border-radius: 4px;
  text-align: center;
  background-color: rgba(64, 158, 255, 0.1);
  color: #409EFF;

  &.error {
    background-color: rgba(255, 73, 73, 0.1);
    color: #ff4949;
  }

  i {
    margin-right: 8px;
    font-size: 16px;
  }
}

.login-tabs {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;

  .tab-item {
    padding: 10px 15px;
    cursor: pointer;
    margin: 0 5px;
    border-bottom: 2px solid transparent;
    transition: all 0.3s;

    &.active {
      border-bottom: 2px solid #409EFF;
      color: #409EFF;
    }

    &:hover:not(.active) {
      color: #66b1ff;
    }
  }
}

.login-form {
  el-form-item {
    margin-bottom: 15px;
  }

  .el-input {
    border-radius: 4px;

    ::v-deep .el-input__inner {
      background-color: transparent;
      color: #fff;
      border: 1px solid rgba(255, 255, 255, 0.2);
    }

    ::v-deep .el-input__prefix {
      color: rgba(255, 255, 255, 0.7);
    }

    ::v-deep .el-input__append {
      padding: 0;
    }
  }

  .code-btn {
    color: #409EFF;
    padding: 0 10px;

    &:disabled {
      color: #999;
    }
  }

  .protocol-link {
    color: #409EFF;
    text-decoration: none;
    margin: 0 4px;
    cursor: pointer;

    &:hover {
      color: #66b1ff;
      text-decoration: underline;
    }
  }

  .agree-protocol-item {
    ::v-deep .custom-checkbox {
      display: flex;
      align-items: flex-start;

      .el-checkbox__label {
        display: block;
        white-space: normal !important;
        word-wrap: break-word;
        line-height: 1.5;
        color: #fff;
        margin-left: 8px !important;
      }

      .el-checkbox__input {
        line-height: 1.7 !important;
      }

      .el-checkbox__inner {
        background-color: transparent;
        border-color: rgba(255, 255, 255, 0.5);
      }

      &.is-checked .el-checkbox__inner {
        background-color: #409EFF;
        border-color: #409EFF;
      }
    }
  }
}

.register-link {
  text-align: center;
  margin-top: 20px;
  padding-top: 15px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

::v-deep .el-input-group__append {
  background-color: transparent !important;
  border: none;
}
</style>